export default __webpack_public_path__ + "static/media/perso_blanc.e3549505.svg";